'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContentWrapper = require('./components/ContentWrapper');

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

var _ScreenReaderTitle = require('./components/ScreenReaderTitle');

var _ScreenReaderTitle2 = _interopRequireDefault(_ScreenReaderTitle);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverlayCTA = function OverlayCTA(_ref) {
  var imgSrc = _ref.imgSrc,
      _ref$contentItems = _ref.contentItems,
      contentItems = _ref$contentItems === undefined ? [] : _ref$contentItems,
      _ref$overlayAlignment = _ref.overlayAlignment,
      overlayAlignment = _ref$overlayAlignment === undefined ? 'full' : _ref$overlayAlignment,
      _ref$overlayColor = _ref.overlayColor,
      overlayColor = _ref$overlayColor === undefined ? 'blue' : _ref$overlayColor,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'normal' : _ref$type;
  return _react2.default.createElement(
    _Wrapper2.default,
    {
      $imgSrc: imgSrc,
      type: type
    },
    _react2.default.createElement(
      _ScreenReaderTitle2.default,
      null,
      'CTA Section'
    ),
    _react2.default.createElement(
      _ContentWrapper2.default,
      {
        alignment: overlayAlignment,
        color: overlayColor,
        type: type
      },
      contentItems
    )
  );
};

OverlayCTA.propTypes = {
  /** a URL for the hero image. */
  imgSrc: _propTypes2.default.string.isRequired,
  /** The content items to display inside the container. */
  contentItems: _propTypes2.default.arrayOf(_propTypes2.default.node),
  /** The alignment of the overlay. */
  overlayAlignment: _propTypes2.default.oneOf(['left', 'right', 'full']),
  /** The color of the overlay. */
  overlayColor: _propTypes2.default.oneOf(['blue', 'red']),
  /** The type of overlay. */
  type: _propTypes2.default.oneOf(['normal', 'tall'])
};

OverlayCTA.displayName = 'OverlayCTA';

exports.default = OverlayCTA;
OverlayCTA.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'OverlayCTA',
  'props': {
    'contentItems': {
      'defaultValue': {
        'value': '[]',
        'computed': false
      },
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'node'
        }
      },
      'required': false,
      'description': 'The content items to display inside the container.'
    },
    'overlayAlignment': {
      'defaultValue': {
        'value': '\'full\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'left\'',
          'computed': false
        }, {
          'value': '\'right\'',
          'computed': false
        }, {
          'value': '\'full\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'The alignment of the overlay.'
    },
    'overlayColor': {
      'defaultValue': {
        'value': '\'blue\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'blue\'',
          'computed': false
        }, {
          'value': '\'red\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'The color of the overlay.'
    },
    'type': {
      'defaultValue': {
        'value': '\'normal\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'normal\'',
          'computed': false
        }, {
          'value': '\'tall\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'The type of overlay.'
    },
    'imgSrc': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'a URL for the hero image.'
    }
  }
};